import React from 'react';

const NoRecordasTarjeta = () => {
    return (
        <>
            <p className="--twoxs --light-neutral-800">
                {' '}
                <strong>¿No recordás el número de la credencial Club LA NACION?</strong> Llamanos al <strong>5199-4700</strong> de Lunes a Viernes de
                8 a 20hs y Sábados de 8 a 14hs.
            </p>
            <br />
            <br />
            <br />
        </>
    );
};

export default NoRecordasTarjeta;
